// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"22dba414","453":"3398875d","876":"53c7dcac"}[chunkId] + ".chunk.js";
};